import React from "react";
import Field from "./../../../components/Fields/Field";
import LayoutControl from "./LayoutControl";
import { RadioButtonListFieldProps } from "./../../../components/Fields/Types";

const LayoutField: React.FC<RadioButtonListFieldProps> = ({ labelProps, controlProps, visible, disabled, layout, options }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <LayoutControl {...controlProps} disabled={disabled} layout={layout} options={options} />
        </Field>
    );
}
export default LayoutField;